export const REACTION_TYPES = ['fire', 'brain', 'cap'];

export const EMOJI_MAP = {
  fire: '🔥',
  brain: '🧠',
  cap: '🧢'
};

export function reactionTypeFromEmoji(emoji) {
  return Object.entries(EMOJI_MAP).find(([, value]) => value === emoji)?.[0] || null;
}

export function summarizeReactions(rows = [], userId = null) {
  const counts = { fire: 0, brain: 0, cap: 0 };
  let activeType = null;

  rows.forEach((row) => {
    const type = reactionTypeFromEmoji(row?.emoji);
    if (!type) return;
    counts[type] += 1;
    if (userId && row.user_id === userId) activeType = type;
  });

  return { counts, activeType };
}

export function summarizeReactionsByDebrief(rows = []) {
  const summaries = new Map();

  rows.forEach((row) => {
    const debriefId = row?.debrief_id;
    const type = reactionTypeFromEmoji(row?.emoji);
    if (!debriefId || !type) return;

    if (!summaries.has(debriefId)) {
      summaries.set(debriefId, { fire: 0, brain: 0, cap: 0 });
    }
    summaries.get(debriefId)[type] += 1;
  });

  return summaries;
}
